package devxertech.com.models

import kotlinx.serialization.Serializable

@Serializable
data class MenuModel(
    val text: String,
    val route: String,
)